import { supabase } from '../lib/supabase'

// Fetch all sports
export const getSports = async () => {
  const { data, error } = await supabase
    .from('sports')
    .select('*')
    .order('name')
  
  if (error) throw error
  return data
}

// Fetch all divisions
export const getDivisions = async () => {
  console.log('getDivisions called')
  console.log('Supabase URL:', import.meta.env.VITE_SUPABASE_URL)
  const { data, error } = await supabase
    .from('divisions')
    .select('*')
    .order('code')
  
  console.log('Supabase response:', { data, error })
  if (error) {
    console.error('Supabase error:', error)
    throw error
  }
  return data
}

// Fetch conferences by division
export const getConferencesByDivision = async (divisionCode) => {
  const { data, error } = await supabase
    .from('conferences')
    .select('*')
    .eq('division_code', divisionCode)
    .order('name')
  
  if (error) throw error
  return data
}

// Fetch schools by conference and division
export const getSchoolsByConference = async (conferenceId, divisionCode) => {
  let query = supabase
    .from('schools')
    .select('*')
    .order('name')
  
  if (conferenceId) {
    query = query.eq('conference_id', conferenceId)
  }
  
  if (divisionCode) {
    query = query.eq('division_code', divisionCode)
  }
  
  const { data, error } = await query
  
  if (error) throw error
  return data
}

// Create or update athlete registration
export const upsertAthlete = async (athleteData) => {
  const { data, error } = await supabase
    .from('athletes')
    .upsert(athleteData, {
      onConflict: 'email',
      ignoreDuplicates: false
    })
    .select()
    .single()
  
  if (error) throw error
  return data
}

// Update athlete registration step
export const updateAthleteStep = async (athleteId, step) => {
  const { data, error } = await supabase
    .from('athletes')
    .update({ registration_step: step })
    .eq('id', athleteId)
    .select()
    .single()
  
  if (error) throw error
  return data
}

// Add agent to athlete
export const addAgent = async (agentData) => {
  const { data, error } = await supabase
    .from('agents')
    .insert(agentData)
    .select()
    .single()
  
  if (error) throw error
  return data
}

// Update agent
export const updateAgent = async (agentId, agentData) => {
  const { data, error } = await supabase
    .from('agents')
    .update(agentData)
    .eq('id', agentId)
    .select()
    .single()
  
  if (error) throw error
  return data
}

// Remove agent
export const removeAgent = async (agentId) => {
  const { error } = await supabase
    .from('agents')
    .delete()
    .eq('id', agentId)
  
  if (error) throw error
  return true
}

// Get athlete's agents
export const getAthleteAgents = async (athleteId) => {
  const { data, error } = await supabase
    .from('agents')
    .select('*')
    .eq('athlete_id', athleteId)
    .order('created_at')
  
  if (error) throw error
  return data
}

// Create NIL profile
export const createNilProfile = async (profileData) => {
  const { data, error } = await supabase
    .from('nil_profiles')
    .insert(profileData)
    .select()
    .single()
  
  if (error) throw error
  return data
}

// Update NIL profile
export const updateNilProfile = async (athleteId, profileData) => {
  const { data, error } = await supabase
    .from('nil_profiles')
    .update(profileData)
    .eq('athlete_id', athleteId)
    .select()
    .single()
  
  if (error) throw error
  return data
}

// Create Story Protocol registration
export const createStoryRegistration = async (registrationData) => {
  const { data, error } = await supabase
    .from('story_registrations')
    .insert(registrationData)
    .select()
    .single()
  
  if (error) throw error
  return data
}

// Update Story Protocol registration
export const updateStoryRegistration = async (athleteId, registrationData) => {
  const { data, error } = await supabase
    .from('story_registrations')
    .update(registrationData)
    .eq('athlete_id', athleteId)
    .select()
    .single()
  
  if (error) throw error
  return data
}

// Get complete athlete registration data
export const getAthleteRegistration = async (athleteId) => {
  const { data: athlete, error: athleteError } = await supabase
    .from('athletes')
    .select('*')
    .eq('id', athleteId)
    .single()
  
  if (athleteError) throw athleteError
  
  // Get agents
  const { data: agents, error: agentsError } = await supabase
    .from('agents')
    .select('*')
    .eq('athlete_id', athleteId)
    .order('created_at')
  
  if (agentsError) throw agentsError
  
  // Get NIL profile
  const { data: nilProfile, error: nilError } = await supabase
    .from('nil_profiles')
    .select('*')
    .eq('athlete_id', athleteId)
    .single()
  
  // Get Story registration
  const { data: storyRegistration, error: storyError } = await supabase
    .from('story_registrations')
    .select('*')
    .eq('athlete_id', athleteId)
    .single()
  
  return {
    athlete,
    agents: agents || [],
    nilProfile: nilProfile || null,
    storyRegistration: storyRegistration || null
  }
}
